import { TApplicationState } from '../../types/redux';

export const selectFormRoomCount = (state: TApplicationState) => state.requestFormV2.quiz.roomCount;
